import { Row } from "@narmi/design_system";
import { catcat as cc } from "cerulean";
import type { JSX } from "react";
import styles from "../DualApproval.module.scss";


export type DrawerRowProps = [string, string | JSX.Element | undefined];

type DrawerRowsProps = {
  rows: DrawerRowProps[];
};

const DrawerRows = ({ rows }: DrawerRowsProps) => (
  <>
    {rows.map(([heading, content], index) => {
      if (!content) return null;
      return (
        <div
          key={`row-${heading}__${index}`}
          className={cc({ "margin--bottom--l": index !== rows.length - 1 })}
        >
          <Row>
            <Row.Item shrink>
              <p className="fontColor--secondary">{heading}</p>
            </Row.Item>
            <Row.Item>
              <div className={styles.rowContent}>
                <span className={styles.ellipsisWrapper}>{content}</span>
              </div>
            </Row.Item>
          </Row>
        </div>
      );
    })}
  </>
);

export default DrawerRows;
